module.exports = __webpack_public_path__ + "img/ljdk_zhTc.ea5984ee.png";